import { useMemo } from 'react';
import useMapArray from './array/useMap';
export function useMap(initialState = new Map()) {
    const [map, actions] = useMapArray(initialState);
    return useMemo(() => (Object.assign({ value: map }, actions)), [actions, map]);
}
export default useMap;
//# sourceMappingURL=useMap.js.map